var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7678 6.26245H2.69531V17.4637H21.7678V6.26245Z",
    stroke: "#F04F2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46094 6.2063C6.46341 6.70033 6.36823 7.18998 6.18089 7.64712C5.99354 8.10426 5.71771 8.51987 5.36924 8.87008C5.02077 9.22029 4.60654 9.49819 4.15034 9.68781C3.69415 9.87744 3.20498 9.97506 2.71094 9.97505",
    stroke: "#F04F2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57031 17.4639C6.56538 16.4708 6.16871 15.5199 5.46652 14.8177C4.76432 14.1155 3.81336 13.7188 2.82031 13.7139",
    stroke: "#F04F2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0625 6.2063C18.0625 7.20583 18.4596 8.16443 19.1663 8.87121C19.8731 9.57799 20.8317 9.97505 21.8312 9.97505",
    stroke: "#F04F2A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.4639C18.0049 16.4708 18.4016 15.5199 19.1038 14.8177C19.806 14.1155 20.757 13.7188 21.75 13.7139",
    stroke: "#F04F2A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6797 8.36255H11.6284C12.5622 8.36255 13.5897 8.6663 13.5897 10.0875C13.5897 11.6288 12.2847 12.2175 10.8972 12.06C10.8808 12.0581 10.8642 12.0614 10.8498 12.0694C10.8354 12.0774 10.8238 12.0897 10.8168 12.1046C10.8097 12.1195 10.8076 12.1363 10.8105 12.1525C10.8135 12.1687 10.8215 12.1836 10.8334 12.195L13.7809 15.375",
    stroke: "#F04F2A",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7181 8.36255H11.4219",
    stroke: "#F04F2A",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7266 10.1362H14.7428",
    stroke: "#F04F2A",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/Rupee.98b69dc7ac2890de08fc7aa385415114.svg";
export { ForwardRef as ReactComponent };